import React from 'react';
import Credentials from './Credentials';
import type { CredentialsProps } from './types';

const CredentialsPage: React.FC<CredentialsProps> = (props) => {
  return <Credentials {...props} />;
};

export default CredentialsPage;
